var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-2",attrs:{"flat":"","color":"grey lighten-4"}},[(_vm.title)?_c('v-card-title',{staticClass:"py-0"},[_c('div',{staticClass:"blue-grey--text"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])]):_vm._e(),_c('v-card-text',{staticClass:"py-0"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }